<template>
  <div class="vue-ui-search">
    <div class="vue-ui-search-placeholder" v-if="input.length === 0" @click="$refs.input.focus()">
      Encontre seu cargo
    </div>
    <img :src="Lupa" alt="lupa" v-if="input.length === 0" />
    <img :src="CircleX" alt="fechar" v-else @click="input = ''" />
    <input v-model="input" @keydown.down.prevent="down" @keydown.up.prevent="up" @keydown.enter="choose" @keydown.esc="close" ref="input" />
    <div v-if="results.length !== 0" class="vue-ui-search-container" ref="container">
      <div class="vue-ui-search-results" v-for="(r, i) in results">
        <div class="vue-ui-search-result-item" :data-index="i === selected" @click="selected = i; choose()">
          <div class="vue-ui-search-result-item-title">
            {{r.cargo}}
          </div>
          <div class="vue-ui-search-result-item-sub">
            {{r.area}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import EventSystem from '../utils/EventSystem';
  import Lupa from 'Assets/images/lupa.svg';
  import CircleX from 'Assets/images/circle-x.svg';

  export default {
    // Vars
    // props: {
    //   data: { required: true }
    // },
    data() {
      return {
        Lupa,
        CircleX,
        input: '',
        selected: 1,
        data: window.$nodes || [],
        currentArea: 'Todas',
      }
    },
    computed: {
      results() {
        if (this.input.length <= 0) return [];
        this.selected = -1;

        var regex = new RegExp(`\\b[^\\s]*(${this.input})[^\\s]*\\b`, 'gi');
        return this.data.filter(d => {
          return d.cargo.match(regex) &&
            (this.currentArea === 'Todas' || this.currentArea === d.direction);
        }).sort((a, b) => a.cargo < b .cargo? -1 : (a.cargo > b.cargo ? 1 : 0));
      }
    },
    // Lifecyle
    created() {
      EventSystem.$on('areas-loaded', () => {
        this.data = window.$nodes;
      });
      EventSystem.$on('area-changed', area => {
        this.currentArea = area;
      });
    },
    updated() {
      const container = this.$refs.container;
      if (!container) return;
      const target = this.$refs.container.querySelector('[data-index]');
      if (!target) return;

      const containerRect = container.getBoundingClientRect();
      const targetRect = target.getBoundingClientRect();

      if (targetRect.y > containerRect.height) {
        container.scrollTop += 54;
      } else if (targetRect.y < containerRect.y) {
        container.scrollTop += targetRect.y - containerRect.y;
      }
    },
    // Methods
    methods: {
      close() {
        this.input = '';
      },
      down(evt) {
        this.selected = Math.min(this.results.length - 1, this.selected + 1);
        evt.stopPropagation();
        return false;
      },
      up(evt) {
        this.selected = Math.max(-1, this.selected - 1);
        evt.stopPropagation();
        return false;
      },
      choose(evt) {
        EventSystem.$emit('selected-node', this.results[this.selected]);
        this.input = '';
      },
    },
  }
</script>



// WEBPACK FOOTER //
// assets/js/source/vue-ui/search.vue